/**
 * Shared value types used by the engine, the client and (from M1) the server.
 * The network protocol is NOT defined here yet; it lives in docs/43 until M1.
 */
export const DIRECTIONS_4 = ['SE', 'SW', 'NE', 'NW'];
/** Paper-doll layers in draw order (vision §6). */
export const PAPER_DOLL_LAYERS = [
    'shadow',
    'body',
    'bottom',
    'shoes',
    'top',
    'outer',
    'hair',
    'headwear',
    'accessory',
    'held',
];
/** VS1 animation set and frame counts (vision §6). */
export const ANIMATION_FRAMES = {
    idle: 4,
    walk: 8,
    sit: 4,
    lie: 4,
    eat: 6,
    phone: 4,
    talk: 4,
    interact: 6,
};
